import { Component, Input } from '@angular/core';
import { Vacancy } from '../core/vacancy';
import { UsingMode } from '../core/review';
import { VacancyService } from '../providers/vacancy.service';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ToasterService } from 'angular5-toaster/angular5-toaster';

@Component({
    selector: 'app-position',
    templateUrl: 'position.component.html',
    styleUrls: ['../pages/vacancy.component.scss']
})
export class PositionComponent {
    @Input() vacancy: Vacancy;
    @Input() usingMode: UsingMode = UsingMode.Anonymous;
    @Input() onDeleting;

    UsingMode = UsingMode;
    isEditing = false;
    vacancyForm: FormGroup;

    constructor(private vacancyService: VacancyService
        , private toaster: ToasterService) { }

    edit() {
        this.isEditing = true;

        if (this.usingMode === UsingMode.God) {
            const dutiesFormArray = [];
            const requirementsFormArray = [];
            this.vacancy.duties.forEach(d => {
                const control = new FormControl(d, Validators.required);
                dutiesFormArray.push(control);
            });
            this.vacancy.requirements.forEach(r => {
                const control = new FormControl(r, Validators.required);
                requirementsFormArray.push(control);
            });

            this.vacancyForm = new FormGroup({
                'title': new FormControl(this.vacancy.title, Validators.required),
                'duties': new FormArray(dutiesFormArray),
                'requirements': new FormArray(requirementsFormArray)
            });
        }
    }

    cancel() {
        this.isEditing = false;
        this.vacancyForm.reset();
        this.vacancyForm = null;
    }

    addEmptyDutyControl() {
        (<FormArray>this.vacancyForm.controls['duties']).push(new FormControl(null, Validators.required));
    }
    removeDutyControl(index: number) {
        (<FormArray>this.vacancyForm.controls['duties']).removeAt(index);
        this.vacancyForm.markAsTouched();
    }

    addEmptyRequirementControl() {
        (<FormArray>this.vacancyForm.controls['requirements']).push(new FormControl(null, Validators.required));
    }
    removeRequirementControl(index: number) {
        (<FormArray>this.vacancyForm.controls['requirements']).removeAt(index);
        this.vacancyForm.markAsTouched();
    }

    onSubmit() {
        const model = this.vacancyForm.value;
        const serializedModel = JSON.stringify(model);

        const result = this.vacancyService.update(this.vacancy.id, serializedModel);
        result.subscribe(updatedVacancy => {
            this.vacancy = updatedVacancy;

            this.toaster.pop('success', null, 'Позиция отредактирована');
        }, error => {
            this.toaster.pop('error', null, error);
        });

        this.vacancy = model;
        this.cancel();
    }

    onDeleteConfirmationClosed(event) {
        if (event && event.needToDelete === true) {
            if (this.onDeleting) {
                this.onDeleting(this.vacancy);
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/position.component.ts